/**
 * Platform-wide documentation that ships with the app (static assets).
 * Markdown entries render in the Documentation page's reading pane;
 * pdf entries are listed under "Documents" as downloads.
 *
 * Paths are relative to the app root — the static deploy prefix
 * (see staticAssetPrefix()) is prepended at runtime.
 */
export interface DocEntry {
  id: string;
  title: string;
  file: string;
  type: 'markdown' | 'pdf';
  description?: string;
}

export const DOCS_MANIFEST: DocEntry[] = [
  {
    id: 'getting-started',
    title: 'Getting started',
    file: 'assets/documents/getting-started.md',
    type: 'markdown',
  },
];
